import Vue from 'vue';

import 'hammerjs'

import Vue2TouchEvents from 'vue2-touch-events'

Vue.use(Vue2TouchEvents)



const KEYCODE_ESC = 27;
const KEYCODE_RIGHT = 39;
const KEYCODE_LEFT = 37;

new Vue({
  el: '#doctor',
  data: function() {
    return {
      length: ~~document.getElementById('doctor').getAttribute('data-length'),
      id: null,
      anim: 'fade'
    }
  },
  methods: {
    onclick: function(id){
      this.anim = 'fade';
      this.id = id;
    },
    next: function(id){
      
      this.anim = 'r';
      this.id = (this.id + this.length + 1) % this.length;
    },
    prev: function(id){
      
      this.anim = 'l';
      this.id = (this.id + this.length - 1) % this.length;
    },
    close: function(){
      this.anim = 'fade';
      this.id = null;
    },
    bodyClass: function(){
      if(this.id !== null){
        $('body').addClass('is_modal');
      }else{
        $('body').removeClass('is_modal');
      }
    },
    keypress: function(e){
      if(this.id === null) return

      switch(e.keyCode){
        case KEYCODE_RIGHT:
          this.next()
        break;

        case KEYCODE_LEFT:
          this.prev()
        break;

        case KEYCODE_ESC:
          this.anim = 'fade';
          this.id = null;
        break;
      }
    },
    wheel: function(e){
      e.stopPropagation();
    }
  },
  mounted: function(){
    this.bodyClass();
    $(window).on('keydown', this.keypress.bind(this));
  },
  watch: {
    "id": function(){
      $('.doctor-modal').scrollTop(0)
      this.bodyClass();
    }
  }
});

